import OurRecommendationsShowcase from './ourRecommendationsShowcase';
import InstantSearchProvider from '@javascript/instant_search/provider/instantSearchProvider';

import type { WithExperiments } from '@javascript/types/Experiment';

type OurRecommendationsShowcaseContainerProps = {
  cashPriceRange: string;
  instantSearchConfig: {
    apiKey: string;
    appId: string;
    indexName: string;
  };
  stockReference: string;
  userToken: string;
};

const OurRecommendationsShowcaseContainer = ({
  cashPriceRange,
  experiments,
  instantSearchConfig,
  stockReference,
  userToken,
}: OurRecommendationsShowcaseContainerProps & WithExperiments) => {
  return (
    <div>
      <InstantSearchProvider
        apiKey={instantSearchConfig.apiKey}
        appId={instantSearchConfig.appId}
        indexName={instantSearchConfig.indexName}
        initialState={null}
        userToken={userToken}
      >
        <OurRecommendationsShowcase
          cashPriceRange={cashPriceRange}
          config={instantSearchConfig}
          experiments={experiments}
          stockReference={stockReference}
          userToken={userToken}
        />
      </InstantSearchProvider>
    </div>
  );
};
export default OurRecommendationsShowcaseContainer;
